<app-card [title]="title" *ngIf="inCard">
    <ng-container *ngTemplateOutlet="content"></ng-container>
</app-card>

<ng-container *ngIf="!inCard">
    <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>

<ng-template #content>
    <div class="row">
        <app-form-field label="Envoyer" [required]="true">
            <app-select
                    [parentFormGroup]="parentFormGroup"
                    parentFormControlName="typeValue"
                    [elements]="triggers"
                    (singleSelectionChanged)="triggerSelected($event?.value)">
            </app-select>
        </app-form-field>

        <app-form-field
                label="Date et heure"
                *ngIf="parentFormGroup.get('time')"
                [required]="true">
            <app-datetime-picker
                    [parentFormGroup]="parentFormGroup"
                    parentFormControlName="time">
            </app-datetime-picker>
        </app-form-field>
    </div>
</ng-template>